import { AppState } from '../../redux/reducers';

//#region Types
interface IProps {
  // Add any props needed
}

interface ConnectedProps {
  OwnerId: string;
}

interface DispatchProps {
  // Add dispatch actions if needed
}

export type Props = IProps & ConnectedProps & DispatchProps;

//#region Redux mapping
export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  OwnerId: state.oidc?.user?.profile?.sub || ''
});

export const mapDispatchToProps = {
  // Add action creators here
};
